var map = {
	"./category.svg": 1513,
	"./comment_count.svg": 8876,
	"./directory.svg": 1306,
	"./home.svg": 8716,
	"./hot.svg": 8146,
	"./like_count.svg": 232,
	"./link.svg": 2873,
	"./menu.svg": 8312,
	"./play.svg": 9231,
	"./return_ico.svg": 6085,
	"./search.svg": 5093,
	"./stop_play.svg": 8350,
	"./view_count.svg": 7018,
	"./volume.svg": 539,
	"./volume_close.svg": 978
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;